/**
 * Trigger a client-side download of an in-memory text file (CSV, JSON, …).
 *
 * Wraps the text in a Blob and clicks a transient anchor, revoking the object
 * URL afterwards. Keeps the Blob/anchor/revoke boilerplate in one place so
 * exporters (audit log, instance logs, …) don't each re-implement it.
 *
 * @param {string} filename — the name the browser saves the file as.
 * @param {string} text — the file contents.
 * @param {string} [mime='text/csv;charset=utf-8;'] — MIME type for the Blob.
 */
export function downloadTextFile(filename, text, mime = 'text/csv;charset=utf-8;') {
  const url = URL.createObjectURL(new Blob([text], { type: mime }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
